import { BaseMapper, clampPercentage } from '@ps/utils';
import { SurveyQuotaUpdate } from '@ps/survey-utils';

import { QuotaUpdateResultDto } from '../dtos/survey-quota.dto';

export class QuotaUpdateMapper extends BaseMapper<
  QuotaUpdateResultDto,
  SurveyQuotaUpdate
> {
  public fromDto(dto: QuotaUpdateResultDto): SurveyQuotaUpdate {
    return {
      psQuotaId: dto.quota_id,
      goal: dto.quantities.current_target,
      currentlyOpen: dto.quantities.currently_open,
      maximum: dto.quantities.maximum,
      allocationPercentage: clampPercentage(dto.quantities.percentage),
      fielded: dto.quantities.achieved,
      locked: dto.locked,
      // The map key is the supplier ref id, and it's the only place it
      // appears — without it these targets can't be matched back to the
      // suppliers already in state.
      supplierTargets: Object.entries(dto.suppliers ?? {}).map(
        ([supplierRefId, supplier]) => ({
          supplierRefId,
          currentTarget: supplier.current_target,
          completeNeeded: supplier.complete_needed,
        }),
      ),
    };
  }
}
